// Odczyt błędów API Szukaj fracht bez zależności od klasy ApiError (duck typing), żeby hooki
// dało się testować z zamockowanym klientem. Front czyta stan z treści odpowiedzi (spec §4.1).

const payloadOf = (error: unknown): Record<string, unknown> | null => {
  if (!error || typeof error !== 'object' || !('payload' in error)) {
    return null
  }
  const payload = (error as { payload?: unknown }).payload
  return payload && typeof payload === 'object' ? (payload as Record<string, unknown>) : null
}

export const errorStatus = (error: unknown): number | null => {
  const status = error && typeof error === 'object' ? (error as { status?: unknown }).status : undefined
  return typeof status === 'number' ? status : null
}

/** `errorKey` z ciała błędu (nowe endpointy), zapasowo `error` (konwencja starszych endpointów). */
export const errorKeyOf = (error: unknown): string | null => {
  const payload = payloadOf(error)
  const key = payload?.errorKey ?? payload?.error
  return typeof key === 'string' && key.trim() ? key.trim() : null
}

/** Sekundy do zwolnienia limitu przy 429 (`retryAfterSeconds` z ciała); null dla innych błędów. */
export const retryAfterSecondsOf = (error: unknown): number | null => {
  if (errorStatus(error) !== 429) {
    return null
  }
  const value = payloadOf(error)?.retryAfterSeconds
  return typeof value === 'number' && Number.isFinite(value) && value > 0 ? Math.ceil(value) : 60
}

const errorName = (error: unknown): string =>
  error && typeof error === 'object' ? String((error as { name?: unknown }).name ?? '') : ''

/** Przerwanie przez nas (AbortController) — nigdy nie jest błędem dla użytkownika. */
export const isAbortError = (error: unknown): boolean => errorName(error) === 'AbortError'

export const isTimeoutError = (error: unknown): boolean => errorName(error) === 'TimeoutError'

/** Jedna cicha ponowna próba po tylu ms, gdy endpointu nie ma (katalog rollback-nowy-front-cofniety-backend). */
export const ENDPOINT_MISSING_RETRY_MS = 2_000

/**
 * Brak endpointu (backend cofnięty albo pody mieszane w trakcie wdrożenia): 404 bez domenowego klucza
 * `spotSearch.*` — `request.notFound` z ProductionExceptionHandler albo 404 bez ciała. 404 domenowe
 * (np. `spotSearch.routes.errors.notFound` — trasa usunięta w innym oknie) to zwykły błąd.
 */
export const isEndpointMissing = (error: unknown): boolean => {
  if (errorStatus(error) !== 404) {
    return false
  }
  const key = errorKeyOf(error)
  return key === null || !key.startsWith('spotSearch.')
}
